export default __webpack_public_path__ + "static/media/max.6e326868.png";